import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'


/* Global State for  favourites
*  Contains:  
*  - Reducers
*  - Actions
*  - async thunks (api calls)
*/



// ------------- PUT for Shares -------------
export const storeShare = createAsyncThunk(


    'metrics/storeShare',
  async (propertyId, thunkAPI) => {
    const state = thunkAPI.getState();
    const sessionId = state.runtime.session.id;

    try {
      const response = await axios.post(`${state.runtime.API_URL}/metrics/properties/record-share`, {
        propertyId,
        sessionId
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);


// ------------- PUT for Clicks -------------
export const storeClick = createAsyncThunk(

    'metrics/storeClick',
    async (propertyId, thunkAPI) => {
    const state = thunkAPI.getState();
    const sessionId = state.runtime.session.id;
        try {
            console.log("storeClick", propertyId);
            const response = await axios.post(`${state.runtime.API_URL}/metrics/properties/record-click`, {
        propertyId,
        sessionId
      });
            return response.status;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);


// ------------- PUT for Views -------------
export const storeView = createAsyncThunk(

    'metrics/storeView',
    async (propertyId, thunkAPI) => {
    const state = thunkAPI.getState();
    const sessionId = state.runtime.session.id;
        try {
            const response = await axios.post(`${state.runtime.API_URL}/metrics/properties/record-view`, {
        propertyId,
        sessionId
      });
            return response.status;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);




const initialState = {

    likesCounter: 0,
    sharesCounter: 0,
    clicksCounter: 0,
    viewsCounter: 0,

    //
    loading: false,
    error: null,
};


// ===========================================
//? reducers, action creators / types

const metricsSlice = createSlice({

    name: 'metrics',
    initialState,

    reducers: {

        gotLiked(state, action) { likesCounter++ },

        gotShared(state, action) { sharesCounter++ },

        gotClicked(state, action) { clicksCounter++ },

        gotViewed(state, action) { viewsCounter++ },

    },

    extraReducers: (builder) => {
        builder
            // ------------ Shares ------------

            .addCase(storeShare.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            .addCase(storeShare.fulfilled, (state, action) => { state.loading = false; })

            .addCase(storeShare.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to add `share` into db";
            })


            // ------------ Clicks ------------

            .addCase(storeClick.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            .addCase(storeClick.fulfilled, (state, action) => { state.loading = false; })

            .addCase(storeClick.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to add `click` into db";
            })

            // ------------ Views ------------

            .addCase(storeView.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            .addCase(storeView.fulfilled, (state, action) => { state.loading = false; })

            .addCase(storeView.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to add `view` into db";
            });
    },
});


// Exports:
export const { gotLiked, gotShared, gotClicked } = metricsSlice.actions;
export default metricsSlice.reducer;
